import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { IconBase } from '@miro-site/core';
import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var rotate = keyframes(["to{stroke-dashoffset:0;}"]);
var Shape = styled.circle.withConfig({
  displayName: "ProgressBar__Shape",
  componentId: "sc-1nb9r2k-0"
})(["fill:", ";stroke:", ";transition:300ms ease;transition-property:fill,stroke;"], function (props) {
  return props.$isActive ? props.theme.colors.primaryIndigo : props.theme.colors.solutionsGray;
}, function (props) {
  return props.$isActive ? props.theme.colors.primaryIndigo : props.theme.colors.solutionsGray;
});
var AnimatedShape = styled.circle.withConfig({
  displayName: "ProgressBar__AnimatedShape",
  componentId: "sc-1nb9r2k-1"
})(["animation-name:", ";animation-duration:", "ms;animation-timing-function:linear;animation-fill-mode:forwards;animation-play-state:", ";"], function (props) {
  return props.$isAnimated ? rotate : 'none';
}, function (props) {
  return props.$duration;
}, function (props) {
  return props.$isPaused ? 'paused' : 'running';
});

var ProgressBar = function ProgressBar(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 25 : _props$size,
      _props$strokeWidth = props.strokeWidth,
      strokeWidth = _props$strokeWidth === void 0 ? 6 : _props$strokeWidth,
      isActive = props.isActive,
      isAnimated = props.isAnimated,
      isPaused = props.isPaused,
      type = props.type,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? 4000 : _props$duration;
  var center = size / 2;
  var radius = size / 2 - strokeWidth / 2;
  var circumference = 2 * Math.PI * radius;
  var perimeter = size * 4;
  return /*#__PURE__*/_jsx(IconBase, _objectSpread(_objectSpread({
    $styles: {
      width: size,
      height: size,
      background: 'primaryWhite',
      borderWidth: 2,
      borderStyle: 'solid',
      borderColor: 'primaryWhite',
      boxShadow: '0 4px 16px rgba(5, 0, 56, 0.12)',
      borderRadius: type === 'rect' ? null : '50%',
      transform: type === 'rect' ? 'rotate(-135deg)' : 'rotate(90deg)'
    },
    viewBox: "0 0 ".concat(size, " ").concat(size)
  }, props), {}, {
    children: type === 'rect' ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Shape, {
        as: "rect",
        width: size,
        height: size,
        fill: "#050038",
        stroke: "#050038",
        strokeWidth: 10,
        $isActive: isActive
      }), /*#__PURE__*/_jsx(AnimatedShape, {
        as: "rect",
        width: size,
        height: size,
        stroke: "#FFD02F",
        strokeWidth: 10,
        strokeDasharray: perimeter,
        strokeDashoffset: perimeter,
        $isAnimated: isAnimated,
        $isPaused: isPaused,
        $duration: duration
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Shape, {
        cx: center,
        cy: center,
        r: center,
        strokeWidth: strokeWidth,
        $isActive: isActive
      }), /*#__PURE__*/_jsx(AnimatedShape, {
        cx: center,
        cy: center,
        r: radius,
        stroke: "#FFD02F",
        strokeWidth: strokeWidth,
        strokeDasharray: circumference,
        strokeDashoffset: circumference,
        $isAnimated: isAnimated,
        $isPaused: isPaused,
        $duration: duration
      })]
    })
  }));
};

export default ProgressBar;